(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "./index.less", "../icon", "../sticky"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("./index.less"), require("../icon"), require("../sticky"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.index, global.icon, global.sticky);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _index, _icon, _sticky) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _icon = _interopRequireDefault(_icon);
  _sticky = _interopRequireDefault(_sticky);

  var _components;

  var _default2 = {
    name: 'nx-sub-header',
    components: (_components = {}, (0, _defineProperty2.default)(_components, _icon.default.name, _icon.default), (0, _defineProperty2.default)(_components, _sticky.default.name, _sticky.default), _components),
    props: {
      type: {
        type: String,
        default: 'normal' // small、normal

      },
      title: {
        type: String,
        default: ''
      },
      extra: {
        type: String,
        default: ''
      },
      isLinkClickable: {
        default: undefined
      },
      arrow: {
        type: Boolean,
        default: false
      },
      subHeaderStyle: {
        type: Object,
        default: function _default() {
          return {
            extraColor: '',
            arrowColor: '',
            backgroundColor: '#fff'
          };
        }
      },
      ariaLabelContent: {
        type: Object,
        default: function _default() {
          return {
            all: '',
            left: '',
            right: ''
          };
        }
      },
      ariaSubHeaderFocus: {
        type: Object,
        default: function _default() {
          return {
            all: false,
            left: true,
            right: true
          };
        }
      },
      sticky: Boolean
    },
    computed: {
      ariaInsideSubHeaderFocus: function ariaInsideSubHeaderFocus() {
        var _this$ariaSubHeaderFo = this.ariaSubHeaderFocus,
            _this$ariaSubHeaderFo2 = _this$ariaSubHeaderFo.all,
            all = _this$ariaSubHeaderFo2 === void 0 ? true : _this$ariaSubHeaderFo2,
            _this$ariaSubHeaderFo3 = _this$ariaSubHeaderFo.left,
            left = _this$ariaSubHeaderFo3 === void 0 ? false : _this$ariaSubHeaderFo3,
            _this$ariaSubHeaderFo4 = _this$ariaSubHeaderFo.right,
            right = _this$ariaSubHeaderFo4 === void 0 ? false : _this$ariaSubHeaderFo4;
        return {
          all: all,
          left: left,
          right: right
        };
      },
      ariaInsideLabelContent: function ariaInsideLabelContent() {
        var _this$ariaLabelConten = this.ariaLabelContent,
            _this$ariaLabelConten2 = _this$ariaLabelConten.all,
            all = _this$ariaLabelConten2 === void 0 ? '' : _this$ariaLabelConten2,
            _this$ariaLabelConten3 = _this$ariaLabelConten.left,
            left = _this$ariaLabelConten3 === void 0 ? '' : _this$ariaLabelConten3,
            _this$ariaLabelConten4 = _this$ariaLabelConten.right,
            right = _this$ariaLabelConten4 === void 0 ? '' : _this$ariaLabelConten4;
        return {
          all: all,
          left: left,
          right: right
        };
      },
      insideLinkClickable: function insideLinkClickable() {
        if (this.isLinkClickable === false || this.isLinkClickable === true) return this.isLinkClickable;else return this.arrow;
      }
    },
    data: function data() {
      return {};
    },
    created: function created() {},
    mounted: function mounted() {},
    destroyed: function destroyed() {},
    methods: {
      onClick: function onClick(e) {
        this.$emit('click', e);
      }
    },
    render: function render() {
      var h = arguments[0];
      var leftTitle = this.$slots.title ? this.$slots.title : h("span", {
        "style": {
          color: this.subHeaderStyle.titleColor || ''
        }
      }, [this.title]);
      var rightExtra = this.$slots.extra ? this.$slots.extra : h("span", {
        "style": {
          color: this.subHeaderStyle.extraColor || ''
        }
      }, [this.extra]);
      var rightArrow = this.arrow ? h("nx-icon", {
        "attrs": {
          "name": "list-arrow-os4"
        },
        "style": {
          color: this.subHeaderStyle.arrowColor || ''
        }
      }) : null;
      var rightContent = this.arrow || this.extra || this.$slots.extra ? h("div", {
        "class": ['nx-sub-header__right', 'nx-sub-header__right--' + this.type, this.insideLinkClickable ? 'nx-sub-header__right--link' : ''],
        "attrs": {
          "tabindex": this.ariaInsideSubHeaderFocus.right ? '1' : undefined,
          "aria-label": this.ariaInsideLabelContent.right || this.extra,
          "role": this.ariaInsideSubHeaderFocus.right && !this.ariaInsideLabelContent.right ? 'button' : ''
        },
        "on": {
          "click": this.onClick
        }
      }, [rightExtra, rightArrow]) : null;
      var dest = h("div", {
        "class": "nx-sub-header",
        "style": this.sticky ? {
          backgroundColor: this.subHeaderStyle.backgroundColor || 'transparent'
        } : null,
        "attrs": {
          "tabindex": this.ariaInsideSubHeaderFocus.all ? '1' : undefined,
          "aria-label": this.ariaInsideLabelContent.all
        }
      }, [h("div", {
        "class": ['nx-sub-header__left', 'nx-sub-header__left--' + this.type],
        "attrs": {
          "tabindex": this.ariaInsideSubHeaderFocus.left ? '1' : undefined,
          "aria-label": this.ariaInsideLabelContent.left || this.title + '，标题',
          "aria-hidden": !this.ariaInsideSubHeaderFocus.left ? 'true' : 'false'
        }
      }, [leftTitle]), rightContent]);
      return this.sticky ? h("nx-sticky", [dest]) : dest;
    }
  };
  _exports.default = _default2;
});